import React from 'react';

import { gql } from '@apollo/client';

import { ActivityLogTaskDebriefRescheduled_ActivityLogFragment } from 'src/generated/mloop-graphql';

import { FCWithFragments } from 'src/components/types';

import ActivityLogBase from '../../Helpers/ActivityLogBase';

interface Fragments {
  activityLog: ActivityLogTaskDebriefRescheduled_ActivityLogFragment;
}

const ActivityLogTaskDebriefRescheduled: FCWithFragments<Fragments> = ({ activityLog }) => {
  return (
    <ActivityLogBase
      activityLog={activityLog}
      actionLabelKey="hiring-dashboard-candidates:candidates.activityLog.rescheduledDebrief"
    />
  );
};

ActivityLogTaskDebriefRescheduled.fragments = {
  activityLog: gql`
    ${ActivityLogBase.fragments.activityLog}
    fragment ActivityLogTaskDebriefRescheduled_activityLog on ActivityLog {
      id

      ...ActivityLogBase_activityLog
    }
  `,
};

export default ActivityLogTaskDebriefRescheduled;
